import { Link, LinkProps } from '@chakra-ui/react'
import { FC } from 'react'

const ExternalLink: FC<LinkProps> = (props) => {
  return (
    <Link
      target="_blank"
      rel="noopener noreferrer"
      fontWeight="700"
      color="green"
      textDecoration="underline !important"
      {...props}
    />
  )
}

export default ExternalLink
